export { default } from './InScreen';
